'use strict';

var WS = global.MozWebSocket || global.WebSocket;

module.exports = {
  create: function(url, protocols, options) {
    if (typeof WS !== 'function') return null;
    return new WS(url);
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/faye/src/util/websocket/browser_websocket.js
// module id = 2309
// module chunks = 0